// extracted by mini-css-extract-plugin
export default {"SortModel":"filter-model_SortModel__Ixijc","title":"filter-model_title__gv-f8","SortSection":"filter-model_SortSection__w8IMO","sortTitle":"filter-model_sortTitle__0wrzJ"};